<div class="detail-info">
    <h2 class="detail-heading">{{'reports.builtup_information' | translate}} <i class="contant-icon" matTooltipPosition="above" matTooltipClass="custom-tooltip" [matTooltip]="'reports.thisSectionPresents' | translate"></i></h2>
    <div class="built-up-info">
        <div class="legendbox">
            <div class="legendbox-chips">
              <span class="chip" *ngIf="totalBuildUpinfo?.total_built_up_area && !isSaudiCheck">{{'reports.totalBuiltUparea' | translate}}: {{ totalBuildUpinfo?.total_built_up_area  | number : "1.0-1" }} {{unitType |translate}} <span>({{ totalBuildUpinfo?.builtup_percentage | number : "1.0-1" }}%)</span></span>
              <span class="chip" *ngIf="totalBuildUpinfo?.floors && totalBuildUpinfo?.floors > 1">{{ totalBuildUpinfo?.floors}} <span class="floorSpan">{{'reports.floors' | translate}}</span> </span>
              <span class="chip" *ngIf="totalBuildUpinfo?.furnishing_status">{{'reports.finish' | translate}} : <span class="floorSpan">{{ totalBuildUpinfo?.furnishing_status}}</span> </span>
            </div>
            <div id="legenddiv" [ngStyle]="{
      'height': buildUpinfo && buildUpinfo?.length > 0 ? '176px' : 'auto', 'margin-top': buildUpinfo && buildUpinfo?.length > 0 ? '30px' : '0'}"></div>
        </div>
        <div class="chartbox">
            <div id="chartdiv" [ngStyle]="{
      'height': buildUpinfo && buildUpinfo?.length > 0 ? '176px' : 'auto'}"></div>
        </div>
    </div>
</div>

